import { render, staticRenderFns } from "./SystemConfigTask.vue?vue&type=template&id=b61de95a&"
import script from "./SystemConfigTask.vue?vue&type=script&lang=js&"
export * from "./SystemConfigTask.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports